import {Form, InputNumber} from "antd";

import "./Filters.css"

export interface FilterNumberProps{
    onChange?:(value:string)=>void
    className?:React.HTMLAttributes<HTMLDivElement>['className'];
    onDeselect?:(value:any)=>void
    onClear?:()=>void
    required?:boolean,
    customRequiredText?:string,
    label?:string,
    placeholder?:string,
    dataKey:string,
    forceUpperCase?:boolean,
    disabled?:boolean,
    defaultValue?:number
}

export function FilterNumber(props:FilterNumberProps){
    const rules=[{ required: props.required ?? false, message: props.customRequiredText ? props.customRequiredText : 'Il campo è obbligatorio' }]

    function onChange(value:any){
        if(props?.onChange){
            props?.onChange(value.target.value)
        }
    }

    const className = "filter " + (props?.className ?? "");

    return  <>
        <Form.Item name={props.dataKey}
                   label={props.label}
                   rules={rules}
                   initialValue={props.defaultValue}
        >
            <InputNumber className={className} defaultValue={props.defaultValue} placeholder={props.placeholder}
                   onChange={onChange} disabled={props.disabled === true}/>
        </Form.Item>
    </>

}